@if (isEditMode) {
  <div class="file-upload-wrapper">
    @if (!isAtFileLimit && !disableAddFile) {
      <div class="dropzone-wrapper">
        <ngx-dropzone class="lna-dropzone" (change)="onSelect($event)">
          <ngx-dropzone-label>
            <span class="dropzone-label">
              {{ 'pages.client.readersCard.uploadFile' | translate }}
            </span>
          </ngx-dropzone-label>
        </ngx-dropzone>
      </div>
    }
    <!--
      The hint used to render only while nothing was attached, and the drop zone hides itself at
      the cap — so the control disappeared with no explanation. Show the count against the limit
      for as long as a limit is set (LNA-1850).
    -->
    @if (maxFiles > 0) {
      <p class="file-counter">
        {{ 'pages.client.readersCard.fileCounter' | translate: { count: totalFileCount, max: maxFiles } }}
        @if (isAtFileLimit) {
          {{ 'pages.client.readersCard.fileLimitReached' | translate }}
        }
      </p>
    }
    @if (files.length || existingFiles.length) {
      <div class="file-list">
        @for (file of existingFiles; track file.outerId) {
          <div>
            <div class="file">
              <img class="file-icon" [attr.alt]="'imgAlt.fileIcon' | translate" src="assets/images/file-icon.svg" />
              <p class="file-name">{{ file.uploadFileName }} ({{ convertBytesToMB(file.length) }})</p>
              @if (!disableDelete) {
                <button (click)="onRemoveExistingFile(file)">
                  <img [attr.alt]="'imgAlt.removeFileIcon' | translate" src="assets/images/remove-file.svg" />
                </button>
              }
            </div>

            <div class="textarea-wrapper" [ngClass]="{ 'd-none': !showDescription }">
              <textarea
                class="form-control lna"
                [(ngModel)]="getExistingFileDescription(file).description"
                (ngModelChange)="emitFilesChanged()"
                rows="5"
                type="text"
                maxlength="{{ maxDescriptionLength }}"
                placeholder="{{ 'pages.client.readersCard.fileDescription' | translate }}"></textarea>
              <p
                class="length"
                [ngClass]="{
                  invalid: getExistingFileDescription(file).description.length > maxDescriptionLength
                }">
                {{ getExistingFileDescription(file).description.length }}/{{ maxDescriptionLength }}
              </p>
            </div>
          </div>
        }
        @for (file of files; track file) {
          <div class="file-container">
            <div>
              <div class="file">
                <img class="file-icon" [attr.alt]="'imgAlt.fileIcon' | translate" src="assets/images/file-icon.svg" />
                <p class="file-name">{{ file.name }} ({{ convertBytesToMB(file.size) }})</p>
                <button (click)="onRemove(file)">
                  <img [attr.alt]="'imgAlt.removeFileIcon' | translate" src="assets/images/remove-file.svg" />
                </button>
              </div>
              <div class="textarea-wrapper" [ngClass]="{ 'd-none': !showDescription }">
                <textarea
                  class="form-control lna"
                  [(ngModel)]="getFileDescription(file.name).description"
                  (ngModelChange)="emitFilesChanged()"
                  type="text"
                  maxlength="{{ maxDescriptionLength }}"
                  placeholder="{{ 'pages.client.readersCard.fileDescription' | translate }}"></textarea>
                <p
                  class="length"
                  [ngClass]="{
                    invalid: getFileDescription(file.name).description.length > maxDescriptionLength
                  }">
                  {{ getFileDescription(file.name).description.length }}/{{ maxDescriptionLength }}
                </p>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <!-- new FILE to add in !isEditing mode -->
  @if (allowToAddNewFile) {
    <div class="file-upload-wrapper">
      <div class="dropzone-wrapper">
        <ngx-dropzone class="lna-dropzone" (change)="onSelectAcceptableFile($event)">
          <ngx-dropzone-label>
            <span class="dropzone-label">
              {{ 'pages.client.readersCard.uploadFile' | translate }}
            </span>
          </ngx-dropzone-label>
        </ngx-dropzone>
      </div>
      <div class="file-list">
        @for (file of filesToAdd; track file) {
          <div class="accept-file-form">
            <div class="file-container">
              <div>
                <div class="file">
                  <img class="file-icon" [attr.alt]="'imgAlt.fileIcon' | translate" src="assets/images/file-icon.svg" />
                  <p class="file-name">{{ file.name }} ({{ convertBytesToMB(file.size) }})</p>
                  <button (click)="onRemove(file, true)">
                    <img [attr.alt]="'imgAlt.removeFileIcon' | translate" src="assets/images/remove-file.svg" />
                  </button>
                </div>
                <div class="textarea-wrapper" [ngClass]="{ 'd-none': !showDescription }">
                  <textarea
                    class="form-control lna"
                    [(ngModel)]="file.description"
                    type="text"
                    maxlength="{{ maxDescriptionLength }}"
                    placeholder="{{ 'pages.client.readersCard.fileDescription' | translate }}"></textarea>
                  <p
                    class="length"
                    [ngClass]="{
                      invalid: file.description?.length > maxDescriptionLength
                    }">
                    {{ file.description?.length ?? 0 }}/{{ maxDescriptionLength }}
                  </p>
                </div>
              </div>
            </div>
            <div class="accept-controls">
              <div class="first-line">
                <div class="label-wrapper">
                  <label class="form-label lna" for="backofficeNote">
                    {{ 'pages.client.readersCard.backofficeNote' | translate }}
                  </label>
                  <input class="form-control" [(ngModel)]="file.backofficeNote" [maxlength]="512">
                </div>
              </div>

              <div class="second-line">
                <div class="term-control-wrapper">
                  <app-date-picker
                    [date]="file.validTill!"
                    [disabled]="file.termType === 'Indefinite'"
                    (dateSelected)="onDateSelectedForNewFile($event, file)"></app-date-picker>
                  <input
                    class="form-check-input lna checkbox"
                    id="isIndefinite_{{ file.outerId }}"
                    [checked]="file.termType === 'Indefinite'"
                    (change)="updateFileIndefinityForNewFile(file, $any($event.target).checked)"
                    type="checkbox" />
                  <label class="checkbox-label" [innerHTML]="'pages.client.readersCard.indefinite' | translate" for="isIndefinite"></label>
                </div>
                <div class="action-button-wrapper">
                  <button class="primary" [disabled]="!isFileValid(file)" (click)="confirmFileForNewFile(file)">
                    {{ 'pages.client.readersCard.acceptFile' | translate }}
                  </button>
                </div>
              </div>
              <div>
                @if (!isFileValid(file)) {
                  <div class="error-wrapper">
                    <small class="error-message">
                      {{ 'components.form.errorRequiredDateOrIndefinite' | translate }}
                    </small>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
  <!-- new FILE to add in !isEditing mode -->
  @for (file of existingFiles; track file.outerId) {
    @if (file.fileNote) {
      @if (selectedFileToEdit.includes(file)) {
        <div class="accept-file-form">
          <div class="file-wrapper">
            <img src="/assets/images/file-icon.svg" alt="file icon" />
            <button class="file" [title]="file.uploadFileName" (click)="downloadFile(file)">
              {{ file.uploadFileName }} ({{ convertBytesToMB(file.length) }})
            </button>
          </div>
          <p class="file-description" [ngClass]="{ last: $index === existingFiles.length - 1 }">
            {{ getExistingFileDescription(file).description }}
          </p>
          <div class="accept-controls">
            <div class="first-line">
              <div class="label-wrapper">
                <label class="form-label lna" for="backofficeNote">
                  {{ 'pages.client.readersCard.backofficeNote' | translate }}
                </label>
                <input class="form-control" [(ngModel)]="file.fileNote.backofficeNote" [maxlength]="512"/>
              </div>
            </div>
            <div class="second-line">
              <div class="term-control-wrapper">
                <app-date-picker
                  [date]="file.fileNote.validTill!"
                  [disabled]="file.fileNote.termType === 'Indefinite'"
                  (dateSelected)="onDateSelected($event, file)"></app-date-picker>
                <input
                  class="form-check-input lna checkbox"
                  id="isIndefinite_{{ file.outerId }}"
                  [checked]="file.fileNote.termType === 'Indefinite'"
                  (change)="updateFileIndefinity(file, $any($event.target).checked)"
                  type="checkbox" />
                <label class="checkbox-label" [innerHTML]="'pages.client.readersCard.indefinite' | translate" for="isIndefinite"></label>
              </div>
              <div class="action-button-wrapper">
                <button
                  class="primary"
                  [disabled]="!(file.fileNote.termType === 'Indefinite' || file.fileNote.validTill)"
                  (click)="confirmFile(file)">
                  {{ 'pages.client.readersCard.acceptFile' | translate }}
                </button>
                <button class="secondary" (click)="cancelEdit(file)">{{ 'pages.client.readersCard.cancelFile' | translate }}</button>
                <button class="secondary" (click)="openDeleteConfirmModal(file)">
                  <img src="assets/images/delete-icon.svg" alt="delete" />
                  {{ 'pages.client.readersCard.removeFile' | translate }}
                </button>
              </div>
            </div>
            <div>
              @if (!(file.fileNote.termType === 'Indefinite' || file.fileNote.validTill)) {
                <div class="error-wrapper">
                  <small class="error-message">
                    {{ 'components.form.errorRequiredDateOrIndefinite' | translate }}
                  </small>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="file-wrapper_container" [ngClass]="{'p-0': noPadding}">
          <div class="file-wrapper">
            @if (isFileExpired(file)) {
              <img src="/assets/images/file-icon-red.svg" alt="file icon" />
            } @else {
              <img src="/assets/images/file-icon.svg" alt="file icon" />
            }
            <button class="file" [ngClass]="{ expired: isFileExpired(file) }" [title]="file.uploadFileName" (click)="downloadFile(file)">
              {{ file.uploadFileName }} ({{ convertBytesToMB(file.length) }})
            </button>
          </div>
          @if (showDescription) {
            <p class="file-description" [ngClass]="{ last: $index === existingFiles.length - 1, expired: isFileExpired(file) }">
              {{ getExistingFileDescription(file).description || '-' }}
            </p>
          }
          @if (file.fileNote.backofficeNote && showBackofficeNote) {
            <div class="label-wrapper">
              <label class="form-label lna" [ngClass]="{ expired: isFileExpired(file) }" for="backofficeNote">
                {{ 'pages.client.readersCard.backofficeNote' | translate }}
              </label>
              <p class="file-description" [ngClass]="{ expired: isFileExpired(file) }">{{ file.fileNote.backofficeNote }}</p>
            </div>
          }
          @if (showTerm) {
            <div class="edit-term_wrapper">
              @if (file.fileNote.termType === 'Indefinite') {
                <p class="term-data m-0">{{ 'pages.client.readersCard.indefinite' | translate }}</p>
              } @else if (file.fileNote.termType === 'Fixed') {
                <p class="term-data m-0" [ngClass]="{ expired: isFileExpired(file) }">
                  {{ 'pages.client.readersCard.validTill' | translate }} {{ formatDate(file.fileNote.validTill!) }}
                </p>
              }
              @if (showApproveDocumentButton && file.fileNote.termType !== 'Unknown') {
                <button class="edit" (click)="onEditFileNote(file)">
                  <img src="assets/images/edit-icon.svg" alt="edit" />
                  {{ 'pages.client.readersCard.editApprovement' | translate }}
                </button>
              }
            </div>
          }
        </div>
        @if (showApproveDocumentButton && file.fileNote.termType === 'Unknown') {
          <div>
            <button class="primary approve-document-btn" (click)="onEditFileNote(file)">
              {{ 'pages.client.readersCard.approveFile' | translate }}
            </button>
          </div>
        }
      }
    } @else {
      <div>
        <div class="file-wrapper">
          <img src="/assets/images/file-icon.svg" alt="file icon" />
          <button class="file" [title]="file.uploadFileName" (click)="downloadFile(file)">
            {{ file.uploadFileName }} ({{ convertBytesToMB(file.length) }})
          </button>
        </div>
        @if (showDescription) {
          <p class="file-description" [ngClass]="{ last: $index === existingFiles.length - 1 }">
            {{ getExistingFileDescription(file).description || '-' }}
          </p>
        }
      </div>
    }
  }

  @if (existingFiles.length === 0) {
    <p class="form-value m-0">-</p>
  }
}

<app-confirm-modal
  [isOpen]="isOpenConfirmDeleteFile"
  (confirm)="onRemoveExistingFileFromAcceptForm(fileToDelete)"
  (cancel)="onModalClose()"
  title="deleteFile" />
